import styled from 'styled-components';

export const DisplayRoot = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
